import { AxiosInstance } from 'axios';

import {
  InstanceAPIApiFactory,
  type Instance,
  type InstanceAPIApiInstanceAPIListInstancesRequest,
} from '@cast/openapi-reporting';

import { AXIOS_CONFIGURATION } from '../constants';

// TODO(Maciej (Mack)): Drop `lowerMetricKeys` once the reporting API returns metric map keys in
// lower_snake_case (matching OpenAPI). Until then the service sends UPPER_SNAKE_CASE (protobuf JSON),
// so we normalize here as a temporary UI-side patch.
const lowerMetricKeys = (row: Instance): Instance => {
  const m = row.metrics;
  if (!m || !Object.keys(m).length) return row;
  return {
    ...row,
    metrics: Object.fromEntries(
      Object.entries(m).map(([k, v]) => [k.toLowerCase(), v])
    ),
  };
};

export const CloudInstancesApiFactory = (client: AxiosInstance) => {
  const generatedApi = InstanceAPIApiFactory(AXIOS_CONFIGURATION, '', client);

  return {
    listInstances: async (
      request: InstanceAPIApiInstanceAPIListInstancesRequest
    ) => {
      const res = await generatedApi.instanceAPIListInstances(request);
      const { data } = res;
      if (!data?.items?.length) return res;
      return {
        ...res,
        data: { ...data, items: data.items.map(lowerMetricKeys) },
      };
    },
  };
};
